// "2026-10-31" (a backend fixture date key / new_date) -> "Saturday October 31 2026".
// Read in UTC: date-only strings parse as UTC midnight, so this gives the key's
// own day in every browser time zone.
const weekdays = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export const formatFixtureDate = (date) => {
  const newDate = new Date(date);
  if (!date || isNaN(newDate)) return "";
  const monthName = newDate.toLocaleString("default", {
    month: "long",
    timeZone: "UTC",
  });
  return `${weekdays[newDate.getUTCDay()]} ${monthName} ${newDate.getUTCDate()} ${newDate.getUTCFullYear()}`;
};
